import React from 'react';

const LeftPointerIcon = () => {
  return (
    <svg className="left-pointer-icon" width="16px" height="11px" viewBox="0 0 16 11" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <desc>Left Pointer icon</desc>
      <defs />
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
        <g id="Locations-Drawer" transform="translate(-41.000000, -37.000000)" className="stroke" stroke="currentColor">
          <g id="Content">
            <g id="Back-Arrow" transform="translate(42.000000, 37.000000)">
              <path d="M14.5,5.5 L0.464331152,5.5" id="Line" />
              <path d="M5.94974747,6.75015599e-14 L0.292893219,5.65685425" id="Line" />
              <path d="M5.94974747,10.9497475 L0.292893219,5.29289322" id="Line" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default LeftPointerIcon;
